export function debounce(func, timeout) {
  let timer
  return (...args) => {
    const next = () => func(...args)
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(next, timeout > 0 ? timeout : 300)
  }
}

export const appendPreloadFactory = () => {
  let urls = []
  const head = document.head

  return (url) => {
    const href = url.href
    if (urls.includes(href)) return

    const preload = document.createElement('link')
    preload.href = href
    preload.rel = 'preload'
    preload.as = 'fetch'
    preload.crossOrigin = 'anonymous'
    head.appendChild(preload)
    urls = [...urls, href]
  }
}